import React, {useState} from 'react';
import './home-projects.scss'
import {getPropsFromState} from "../../../redux/mapStateToProps";
import {AddSubscribers} from "../../../redux/actions";
import {connect} from "react-redux";
import {Swiper, SwiperSlide} from "swiper/react";
import {Autoplay, Navigation, Pagination} from "swiper/modules";
import {generateFileMediaUrl} from "../../../utils/generateMediaUrl";
import {Link} from "react-router-dom";
import {getUrlWithLocal} from "../../../utils/getUrlWithLocal";

function HomeProjects(props) {
    const {works,staticTexts} = props
    const [activeIndex,setActiveIndex] = useState(false);

    return <div className={'projects_wrapper'}>
        <div  className={'projects_title'}>
            {staticTexts?.homepage_projects_title || 'Реализованные проекты'}
        </div>
        <div className={'projects_slider'}>
            <Swiper
                effect={'flip'}
                spaceBetween={'30'}
                watchSlidesProgress={true}
                slidesPerView={1.3}
                pagination={false}
                modules={[Autoplay,Navigation, Pagination]}
                navigation={false}
                loop={true}
                allowTouchMove={true}
                autoplay={{
                    delay: 2000,
                    disableOnInteraction: false,
                }}
                onRealIndexChange={(swiper) => {
                    setActiveIndex(swiper.realIndex)
                }}
                breakpoints={{
                    400: {
                        slidesPerView: 1.3,
                    },
                    600: {
                        slidesPerView: 2,
                    },
                    800: {
                        slidesPerView: 3,
                    },
                    1000: {
                        slidesPerView: 4,
                    },
                    1300: {
                        slidesPerView: 5,
                    },
                    1600: {
                        slidesPerView: 5,
                    },
                }}
            >

                {
                    works?.map((item, index) => {
                        return <SwiperSlide key={index} className={'projects_img_wrapper'}>
                            <Link to={getUrlWithLocal(`/works/detail/${item?.id}`)} className={'projects_img_block'}>
                                <img src={generateFileMediaUrl(item?.mediaMain?.path)} alt="" className={'projects_img'}/>
                            </Link>
                            <span className={'project_item_title'}>{item?.title}</span>
                        </SwiperSlide>
                    })
                }
            </Swiper>
        </div>
        <Link to={getUrlWithLocal('/works/all')} className={'project_link'}>
            {staticTexts?.homepage_projects_link_btn || 'перейти к проектом'}
        </Link>
    </div>

}
const mapStateToProps = (state) => getPropsFromState(state, [
    'staticTexts',
    'requestLoading',
    'works'
]);

const mapDispatchToProps = {
    AddSubscribers
};

export default connect(mapStateToProps, mapDispatchToProps)(HomeProjects);